import { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'

import BaseIcon from 'assets/svg/providers/base.svg'
import EthereumIcon from 'assets/svg/providers/ethereum.svg'
import OptimismIcon from 'assets/svg/providers/optimism.svg'
import InputHeaderRow from 'components/Input/InputHeaderRow'
import { FlexDivCol } from 'components/layout/flex'
import LabelContainer from 'components/Nav/DropDownLabel'
import Select from 'components/Select'
import { SUPPORTED_WATCHER_MODE_NETWORKS } from 'constants/network'
import { chains } from 'containers/Connector/config'

import { IndicatorSeparator, DropdownIndicator } from '../../../components/Select'

type NetworkSelectProps = {
	onChange: Dispatch<SetStateAction<SelectedProviderNetwork>>
	value: {
		label: string
		value: string
	}
}

export type SelectedProviderNetwork = {
	label: string
	value: string
	networkId: number
}

export const NETWORK_OPTIONS = chains
	.filter((c) => SUPPORTED_WATCHER_MODE_NETWORKS.includes(c.id))
	.map((chain) => ({
		label: chain.name,
		value: chain.name,
		networkId: chain.id,
	}))

const NetworkIcon = (networkName: string) => {
	switch (networkName) {
		case 'Ethereum':
		case 'Goerli':
			return <EthereumIcon width={24} height={16} />
		case 'Base Goerli':
		case 'Base':
			return <BaseIcon width={24} height={16} />
		default:
			return <OptimismIcon width={24} height={16} />
	}
}

const NetworkSelect = ({ value, onChange }: NetworkSelectProps) => {
	const formatOptionLabel = ({ value }: any) => (
		<StyledLabelContainer noPadding={!!value}>
			{!!value && <PrefixIcon>{NetworkIcon(value)}</PrefixIcon>}
			{value}
		</StyledLabelContainer>
	)

	return (
		<FlexDivCol>
			<InputHeaderRow label="Network" />
			<StyledNetworkSelect
				variant="flat"
				menuWidth={'100%'}
				onChange={onChange}
				value={value}
				maxMenuHeight={140}
				formatOptionLabel={formatOptionLabel}
				components={{ IndicatorSeparator, DropdownIndicator }}
				options={NETWORK_OPTIONS}
			/>
		</FlexDivCol>
	)
}

export default NetworkSelect

export const StyledNetworkSelect = styled(Select)`
	.react-select__single-value * {
		font-family: ${(props) => props.theme.fonts.mono};
	}

	.react-select__control {
		border-radius: 8px;
	}
`

const PrefixIcon = styled.span`
	display: flex;
`

const StyledLabelContainer = styled(LabelContainer)`
	justify-content: flex-start;
	gap: 5px;
`
